import { render, staticRenderFns } from "./gifts.vue?vue&type=template&id=4805a2ed&scoped=true"
import script from "./gifts.vue?vue&type=script&lang=js"
export * from "./gifts.vue?vue&type=script&lang=js"
import style0 from "./gifts.vue?vue&type=style&index=0&id=4805a2ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4805a2ed",
  null
  
)

export default component.exports